<template>
  <el-dialog :model-value="visible" title="选择内容类型" width="fit-content" align-center @update:model-value="$emit('update:visible', $event)">
    <div v-if="multiple">
      <table class="my-table" border="1">
        <thead>
          <tr>
            <th class="col-kpi">内容类型</th>
            <th class="col-name">显示名称</th>
            <th class="col-action">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in values" :key="index">
            <td><el-select-v2 v-model="item.kpiId" :options="options" :props="{ value: 'id', label: 'name' }" @change="$emit('change-kpi-id', $event, index)" /></td>
            <td><el-input v-model="item.name" /></td>
            <td><el-button type="danger" size="small" circle icon="Delete" @click="values.splice(index, 1)" /></td>
          </tr>
        </tbody>
      </table>

      <div class="add-row">
        <el-button type="primary" size="small" circle icon="Plus" @click="values.push({ kpiId: null, name: '' })" />
      </div>
    </div>

    <el-form v-else :model="form" class="kpi-form">
      <el-form-item label="内容类型">
        <el-select-v2 v-model="form.kpiId" :options="options" :props="{ value: 'id', label: 'name' }" @change="$emit('change-kpi-id', $event)" />
      </el-form-item>
      <el-form-item label="显示名称">
        <el-input v-model="form.name" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="info" @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="$emit('confirm')">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
defineProps({
  visible: Boolean,
  multiple: Boolean,
  options: Array,
  form: Object,
  values: Array
})

defineEmits(['update:visible', 'change-kpi-id', 'confirm'])
</script>

<style lang="scss" scoped>
.my-table {
  .col-kpi,
  .col-name {
    width: 220px;
  }

  .col-action {
    width: 80px;
  }
}

.add-row {
  margin-top: 15px;
}

.kpi-form {
  width: 400px;
}
</style>
